import { systemFonts } from './constants';

const FONT_GROUPS = Object.freeze({
  Popular: [
    'San Francisco',
    'Helvetica Neue',
    'Helvetica',
    'Arial',
    'Roboto',
    'Open Sans',
    'Lato',
    'Montserrat',
  ],
  'Sans-Serif': [
    'Arial',
    'Helvetica',
    'Helvetica Neue',
    'Verdana',
    'Calibri',
    'Segoe UI',
    'San Francisco',
    'Roboto',
    'Open Sans',
    'Lato',
    'Montserrat',
    'Nunito',
    'Inter',
    'Poppins',
    'Source Sans Pro',
    'Josefin Sans',
    'Work Sans',
    'Quicksand',
  ],
  Serif: [
    'Times New Roman',
    'Georgia',
    'Garamond',
    'Playfair Display',
    'Merriweather',
    'PT Serif',
    'Lora',
    'Domine',
    'EB Garamond',
    'Crimson Text',
    'Abril Fatface',
  ],
  Monospace: [
    'Courier New',
    'Lucida Console',
    'Fira Code',
    'Roboto Mono',
    'Source Code Pro',
    'Inconsolata',
    'JetBrains Mono',
  ],
  Display: [
    'Oswald',
    'Raleway',
    'Lobster',
    'Pacifico',
    'Bebas Neue',
    'Cinzel',
    'Great Vibes',
  ],
});

const FONT_GROUP_LOOKUP = Object.freeze(
  Object.entries(FONT_GROUPS).reduce((acc, [group, fonts]) => {
    fonts.forEach(font => {
      acc[font] = group;
    });
    return acc;
  }, {})
);

const ALL_FONT_NAMES = Object.freeze(
  Array.from(
    new Set(
      Object.values(FONT_GROUPS).reduce((acc, names) => acc.concat(names), [])
    )
  )
);

const SANS_FALLBACK = 'Arial, Helvetica, sans-serif';
const SERIF_FALLBACK = "'Times New Roman', Times, serif";
const MONO_FALLBACK = "'Courier New', Courier, monospace";
const HELVETICA_NEUE_STACK = `'Helvetica Neue', Helvetica, Arial, sans-serif`;
const SAN_FRANCISCO_STACK =
  "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Helvetica Neue', Helvetica, Arial, sans-serif";

export function getFontStack(fontName) {
  if (!fontName || typeof fontName !== 'string') {
    return SANS_FALLBACK;
  }
  const trimmed = fontName.trim();
  if (!trimmed) return SANS_FALLBACK;

  // If the incoming value already looks like a stack, return as-is
  if (trimmed.includes(',')) return trimmed;

  const normalized = trimmed.toLowerCase();
  if (normalized === 'helvetica neue') {
    return HELVETICA_NEUE_STACK;
  }
  if (normalized === 'san francisco' || normalized === '-apple-system') {
    return SAN_FRANCISCO_STACK;
  }

  const group = FONT_GROUP_LOOKUP[trimmed];
  const needsQuotes = /\s/.test(trimmed) || trimmed.includes('-');
  const primary = needsQuotes ? `'${trimmed}'` : trimmed;

  if (group === 'Monospace') {
    return `${primary}, ${MONO_FALLBACK}`;
  }

  if (group === 'Serif') {
    return `${primary}, ${SERIF_FALLBACK}`;
  }

  if (systemFonts.has(trimmed)) {
    return `${primary}, ${SANS_FALLBACK}`;
  }

  return `${primary}, ${SANS_FALLBACK}`;
}

export const FONT_STYLE_OPTIONS = Object.freeze(
  ALL_FONT_NAMES.map(name => ({
    id: getFontStack(name),
    label: name,
  }))
);

export const FONT_GROUPED_OPTIONS = FONT_GROUPS;
export const ALL_FONT_NAMES_LIST = ALL_FONT_NAMES;
export const DEFAULT_FONT_FAMILY = 'Roboto';
